import se from "../in-app-message-manager-factory.js";
import r from "../../managers/braze-instance.js";
import { setupInAppMessageUI as ss } from "../../ui/js/index.js";
import { showInAppMessage } from "./show-in-app-message.js";
import { subscribeToInAppMessage } from "../subscribe-to-in-app-message.js";
export function automaticallyShowInAppMessages() {
  if (!r.rr()) return;
  ss();
  var s = se.ea();
  if (null == s.xi()) {
    var _r = subscribeToInAppMessage(function (s) {
      return showInAppMessage(s);
    });
    s.Pi(_r);
  }
  return s.xi();
}